/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import { Card, CardHeader, CardContent, CardActions, Paper, Typography, Divider, Chip, Tooltip, IconButton, Dialog, Link, Button } from '@material-ui/core';

import JSONAvatar from '../../Avatars/JSONAvatar';
import EMAILAvatar from '../../Avatars/EMAILAvatar';
import SMAvatar from '../../Avatars/SMAvatar';
import BOTAvatar from '../../Avatars/BOTAvatar';

import Attachment from './components/Attachment'

import CTAButton from '../../CTAButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Highlighter from "react-highlight-words";
import { Fullscreen, FullscreenExit } from '@material-ui/icons';

const styles = theme => ({
    highlight : {
        backgroundColor: 'rgba(149,223,255,0.65)',
        padding : 0
    }
})

const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
});

const config = {
    type : 'sm'
}

class JSONViewer extends Component {
    component_width = React.createRef();
    popper_height = React.createRef();

    state = {
        color : "",
        labels : [],
        grouped : this.props.record.grouped,
        location_index : null,
        full_screen : false,
        width : null,
        popper_height : null
    }

    componentWillMount () {
        console.log("JSON Viewer Props: ", this.props)
        if (this.state.grouped) {
            this.setState({
                ...this.state,
                location_index : this.props.location_index
            })
        }
    }

    componentDidMount () {
        const width = this.component_width.current.clientWidth - 50
        const popper_height = this.popper_height.current.clientHeight + 150
        this.setState({...this.state,width : width, popper_height : popper_height})
        // let labels = []
        // this.props.config.display.map(config => {
        //     if (config.style === 'label') {
        //         labels.push(config)
        //     }
        // })
        // this.setState({...this.state, labels : labels})
    }

    getRecordContent = () => {
        if (this.props.record.grouped) {
            return this.props.record.group[this.props.location_index]
        } else {
            return this.props.record
        }
    }

    renderAvatar = () => {
        if (this.props.config.props.type === 'json') {
            return <JSONAvatar disabled = {false}/>
        } else if (this.props.config.props.type === 'sm') {
            return <SMAvatar disabled = {false}/>
        } else if (this.props.config.props.type === 'email') {
            return <EMAILAvatar disabled = {false}/>
        } else if (this.props.config.props.type === 'email') {
            return <BOTAvatar disabled = {false}/>
        }
    }

    renderIdLabel = () => {
        let id_label
        id_label = this.props.config.name

        return id_label
    }

    renderId = () => {
        // let id_index = this.props.config.display.findIndex(el => el.style === 'id')
        // let display_config = this.props.config.display[id_index]
        // console.log('Display Config :', display_config)
        let id
        if (this.props.edit === true) {
            if (this.props.config.id_key_source === "") {
                id = ""
            } else {
                id = this.props.config.id_key_source + "/" + this.props.config.id_key_name
            }
        } else {
            id = this.getContentValue(this.props.config.id_key_source, this.props.config.id_key_name, this.getRecordContent())
            console.log('ID: ', id)
        }
        return (
            <div style={{width : "100%", wordWrap : "break-word"}}>
                {id}
            </div>
        )  
        //return id
    }

    renderCardHeader = () => {
        return (
            <CardHeader
                avatar = {this.renderAvatar()}
                subheader = {this.renderIdLabel()}
                title = {this.renderId()}
                disableTypography = {false}
                titleTypographyProps = {{
                    style : {
                        fontWeight: 'bold',
                        maxWidth: '200px',
                    },
                    color: 'primary',
                }}
                subheaderTypographyProps = {{
                    color: 'textSecondary',
                    tabIndex : 0
                }}
                action={
                    <div style = {{display : 'flex', flexDirection : 'row-reverse', alignItems : 'center', marginRight : '5px'}}>
                        {this.props.edit === false && this.props.cta_enabled && <CTAButton cta_config={this.props.cta_config} record={this.props.record} popper_width={this.state.width} popper_height={this.state.popper_height}></CTAButton>
                        // <Button
                        //     variant = 'contained'
                        //     color = 'primary'
                        //     size = 'small'
                        //     onClick = {() => this.props.execute_cta(this.props.cta_config, this.props.record)}
                        // >{this.props.cta_config.button_label}</Button>
                        }
                        <Tooltip title = "Toggle Fullscreen">
                            <IconButton style = {{marginRight : '5px'}} aria-label="settings" onClick = {() => this.setState({...this.state, full_screen : !this.state.full_screen})}>
                            {this.state.full_screen ? <FullscreenExit/> : <Fullscreen/>}
                            </IconButton>
                        </Tooltip>
                    </div>
                }
            />
        )
    }

    renderFieldAttachments = (display_config, record) => {
        console.log("Field Attachments : Display Config : ", display_config)
        console.log("Field Attachments : Record : ", record)

        if (display_config.field_attachments) {
            if (display_config.key_source === 'raw_data') {
                let field = record.raw_fields.fields.find(field => field.name === display_config.key_name)

                if (Array.isArray(field.attachment_meta_data_list)) {
                    if (field.attachment_meta_data_list.length > 0) {
                        let attachments = field.attachment_meta_data_list.map(attachment => {
                            console.log("Attachment : ", attachment)
                            if (attachment.file_wv_address !== null) {
                                return (
                                    <Attachment
                                        width = '33%'
                                        attachment = {attachment}
                                        show_title = {true}
                                        show_view = {true}
                                        server_name = {attachment.file_wv_address.wv_server_name}
                                        search_string = {this.props.search_string}
                                        file_id = {attachment.file_wv_address.wv_id}
                                        file_name = {attachment.file_name}
                                        file_type = {attachment.content_type}
                                        path = {attachment.content_type}
                                        record = {this.props.record}
                                        drl_url = {this.props.drl_url}
                                        re_attach = {this.props.re_attach}
                                        attach_options = {this.props.attach_options}
                                        re_attach_attachment = {(field_option, attachment_object) => this.props.re_attach_attachment(field_option, attachment_object)}
                                    />
                                )
                            } else {
                                return (<div></div>)
                            }
                        })
    
                        return (
                            <div style = {{width : '100%', margintop : '5px'}}>
                                <Typography variant = 'caption' color = 'primary'>Attachments</Typography>
                                <div style = {{width : '100%', display : 'flex', flexDirection : 'row', flexWrap: 'wrap',}}>
                                    {attachments}
                                </div>
                            </div>
                        )
                    }
                }
            }
        }
    }

    getEmbeddedAttachments = (key_source, key_name, record) => {
        if (this.props.edit === false) {
            if (key_name !== null && key_name !== "") {
                console.log("WV || CV Key Name : ", key_name)
                if (key_source === 'raw_data') {
                    let value = this.getEmbeddedAttachmentsFromRawData(key_name, record)
                    return value
                }
            }
        }
    }

    getEmbeddedAttachmentsFromRawData = (key_name, record) => {
        let raw_fields = record.raw_fields
        let field_data = raw_fields.fields.find(field => field.name === key_name)
        let value = field_data.embedded_attachment_meta_data
        return value
    }

    getEmbeddedAttachmentObject = (key_name, record, attachment_identifier) => {
        let hash = attachment_identifier.substring(21, attachment_identifier.length -1)
        console.log("Embedded Attachments Hash: ", hash)
        let raw_fields = record.raw_fields
        let field_data = raw_fields.fields.find(field => field.name === key_name)
        let embedded_attachments = field_data.embedded_attachment_meta_data
        console.log("Embedded Attachments Objects: ", embedded_attachments)
        let attachment_object = embedded_attachments.find(attachment => attachment.inlineHash === hash)
        return attachment_object
    }

    renderFieldValue = (display_config, record) => {
        console.log('Display Config :: ', display_config)
        let value = this.getContentValue(display_config.key_source, display_config.key_name, record)
        let display_inline_attachments = display_config.embedded_attachments
        let inline_attachments = this.getEmbeddedAttachments(display_config.key_source, display_config.key_name, record)
        if (inline_attachments) {
            if (inline_attachments.length > 0) {
                //value = value.split(/([SAINAPSE_ATTACHMENT:[ A-Za-z0-9_@./#&+-]*])/g)
                value = value.split(/(\[SAINAPSE_ATTACHMENT:[ A-Za-z0-9_@./#&+-]*\])/)
                
                console.log("Embedded Attachments Tag :", value)
                let content = value.map(val => {
                    if (val[0] === '[' && val[val.length -1] === ']') {
                        //console.log("Embedded Attachments Object: ", this.getEmbeddedAttachmentObject(display_config.key_name, record, val))
                        let attachment = this.getEmbeddedAttachmentObject(display_config.key_name, record, val)
                        console.log("Attachment Object : ", attachment)
                        if (display_inline_attachments) {
                            if (attachment) {
                                if (attachment.file_wv_address !== null) {
                                    return (
                                        <Attachment
                                            width = '33%'
                                            attachment = {attachment}
                                            show_title = {true}
                                            show_view = {true}
                                            server_name = {attachment.file_wv_address.wv_server_name}
                                            search_string = {this.props.search_string}
                                            file_id = {attachment.file_wv_address.wv_id}
                                            file_name = {attachment.file_name}
                                            file_type = {attachment.content_type}
                                            path = {attachment.content_type}
                                            record = {this.props.record}
                                            drl_url = {this.props.drl_url}
                                            re_attach = {this.props.re_attach}
                                            attach_options = {this.props.attach_options}
                                            re_attach_attachment = {(field_option, attachment_object) => this.props.re_attach_attachment(field_option, attachment_object)}
                                        />
                                    )
                                } else if (attachment.link_info.type === "HYPERLINK") {
                                    return (
                                        <Typography display = 'block' variant = 'body2' color = 'textPrimary'>
                                            <Link color = 'primary'>{attachment.link_info.originalLink}</Link>
                                        </Typography>
                                    )
                                } else {
                                    return (<Typography display = 'block' variant = 'caption' color = 'textSecondary'>Unable to fetch inline attachment</Typography>)
                                }
                            } else {
                                return (<Typography display = 'block' variant = 'caption' color = 'textSecondary'>Unable to fetch inline attachment</Typography>)
                            }
                        } else {
                            return (<Typography display = 'block' variant = 'caption' color = 'textSecondary'>Inline attachment blocked.</Typography>)
                        }
                    } else {
                        return (
                            <Typography 
                                style = {{display: 'block', whiteSpace : 'pre-wrap'}} 
                                variant = 'body1' 
                                dangerouslySetInnerHTML = {{__html: val}}
                            ></Typography>
                        )
                    }
                })

                return content
            } else {
                return (
                    <Typography 
                        style = {{display: 'block', whiteSpace : 'pre-wrap'}} 
                        variant = 'body1' 
                        dangerouslySetInnerHTML = {{__html: this.getContentValue(display_config.key_source, display_config.key_name, record)}}
                    >
                    </Typography>
                )
            }
        } else {
            return (
                <Typography 
                    style = {{display: 'block', whiteSpace : 'pre-wrap'}} 
                    variant = 'body1' 
                    dangerouslySetInnerHTML = {{__html: this.getContentValue(display_config.key_source, display_config.key_name, record)}}
                >
                </Typography>
            )
        }
    }

    renderContent = (display_config, record) => {
        let style = display_config.style
        if (style === 'body') {
            return (
                <Fragment>
                    <div style = {{display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                        <Typography style = {{display: 'block', flexGrow : 1}} variant = 'overline' color = 'primary'>{display_config.label}</Typography>
                        <Tooltip title = {"Copy " + display_config.label}>
                            <div>
                                <FontAwesomeIcon style = {{color : "#00B5FE"}} icon = {["fad", "copy"]} onClick = {() => this.props.copy_text(this.getContentValue(display_config.key_source, display_config.key_name, record))}/>
                            </div>
                        </Tooltip>
                    </div>
                    {this.props.edit === false ? 
                        <>
                            {this.renderFieldValue(display_config, record)}
                            {/* <Typography 
                                style = {{display: 'block', whiteSpace : 'pre-wrap'}} 
                                variant = 'body1' 
                                dangerouslySetInnerHTML = {{__html: this.getContentValue(display_config.key_source, display_config.key_name, record)}}
                            >
                            </Typography> */}
                            {this.renderFieldAttachments(display_config, record)}
                        </> : 
                        <Typography style = {{display: 'block'}} variant = 'caption' color = 'textSecondary'>
                            {"Here the value from " + display_config.key_source + "/" +  display_config.key_name + " will be populated."}
                        </Typography>}
                    
                    <Divider style = {{marginTop : '5px', marginBottom : '5px'}} />
                </Fragment>
            )
        }
    }

    getLabels = () => {
        let labels = []
        this.props.config.display.map(config => {
            if (config.style === 'label') {
                labels.push(config)
            }
        })

        return labels
    }

    getHighlightedContent = (key_source, key_name, record) => {
        const { classes } = this.props
        return (
            <Highlighter
                highlightClassName = {classes.highlight}
                searchWords = {this.props.key_terms}
                autoEscape = {true}
                findChunks={this.findChunksAtBeginningOfWords}
                textToHighlight = {this.getContentValue(key_source, key_name, record)}
            />
        )
    }

    findChunksAtBeginningOfWords = ({
        autoEscape,
        caseSensitive,
        sanitize,
        searchWords,
        textToHighlight
      }) => {
        const chunks = [];
        const textLow = textToHighlight.toLowerCase();
        // Match at the beginning of each new word
        // New word start after whitespace or - (hyphen)
        const sep = /[-\s]+/;
    
        // Match at the beginning of each new word
        // New word start after whitespace or - (hyphen)
        const singleTextWords = textLow.split(sep);
    
        // It could be possible that there are multiple spaces between words
        // Hence we store the index (position) of each single word with textToHighlight
        let fromIndex = 0;
        const singleTextWordsWithPos = singleTextWords.map(s => {
          const indexInWord = textLow.indexOf(s, fromIndex);
          fromIndex = indexInWord;
          return {
            word: s,
            index: indexInWord
          };
        });
    
        // Add chunks for every searchWord
        searchWords.forEach(sw => {
          const swLow = sw.toLowerCase();
          // Do it for every single text word
          singleTextWordsWithPos.forEach(s => {
            if (s.word.startsWith(swLow)) {
              const start = s.index;
              const end = s.index + swLow.length;
              chunks.push({
                start,
                end
              });
            }
          });
    
          // The complete word including whitespace should also be handled, e.g.
          // searchWord='Angela Mer' should be highlighted in 'Angela Merkel'
          if (textLow.startsWith(swLow)) {
            const start = 0;
            const end = swLow.length;
            chunks.push({
              start,
              end
            });
          }
        });
    
        return chunks;
      };

    getContentValue = (key_source, key_name, record ) => {
        try{
        let value = null
        if (this.props.edit === false) {
            if (key_name !== null && key_name !== "") {
                console.log("WV || CV Key Name : ", key_name)
                if (key_source === 'wv_fields') {
                    value = this.getValueFromWV(key_name, record)
                } else if (key_source === 'source_info') {
                    value = this.getValueFromIUSource(key_name, record)
                } else if (key_source === 'raw_data') {
                    value = this.getValueFromRawData(key_name, record)
                }
            }
        }

        if (value && typeof value === "string") {
            value = value.replace(/(?:\r\n|\r|\n)/g, '<br>')
        }
        return value
    }
    catch(err){
        console.log(err)
        return ""
    }
    }

    getValueFromWV = (key_name, record ) => {
        try{
        console.log("WV || Key Name: ", key_name)
        let world_view = record.wv_field_list
        console.log("WV || Field List: ", world_view)
        let field_index = world_view.findIndex(field => field.name === key_name)
        console.log("WV || Field Index: ", field_index)
        let value = world_view[field_index].value.text

        return value
        }
        catch(err){
            console.log(err)
            return ""
        }
    }

    getValueFromIUSource = (key_name, record ) => {
        let value = record.iu_record_src_info.iu_record_nav_info.location.position
        return value
    }

    getValueFromRawData = (key_name, record ) => {
        let raw_fields = record.raw_fields
        let field_data = raw_fields.fields.find(field => field.name === key_name)
        let value = field_data.value
        return value
    }

    renderLabels = (labels) => {
        return (
            <div ref = {this.popper_height} style = {{display: 'flex', flexDirection : 'row', flexWrap : 'wrap', width : '100%', marginBottom : '10px'}}>
                {
                    labels.map(label => {
                        return (
                            // <Paper variant = 'outlined' style = {{ padding : '5px', width : '25%'}}>
                            //     <Typography style = {{display: 'block'}} variant = 'caption' color = 'primary'>{label.label}</Typography>
                            //     <Typography style = {{display: 'block'}} variant = 'subtitle2'>{this.getContentValue(label.key_source, label.key_name, this.props.record)}</Typography>
                            // </Paper>
                            <Chip style = {{margin: '5px'}} size = 'small' color = 'primary' label = {
                                <Typography variant = 'subtitle2'>
                                    <Typography display = 'inline' variant = 'caption'>{label.label}</Typography>
                                     : {this.props.edit === false ? this.getContentValue(label.key_source, label.key_name, this.getRecordContent()) : label.key_source + "/" +  label.key_name}
                                    </Typography>
                            }/>
                        )
                    })
                }
            </div>
        )
    }

    renderAttachments = (record) => {
        let show_global_attachments = false

        let show_global_attachments_param = this.props.config.params.find(param => param.key === "global_attachments")

        if (show_global_attachments_param) {
            show_global_attachments = show_global_attachments_param.value.boolean
        }

        if (show_global_attachments) {
            if (record.raw_fields.record_level_attachments.length > 0) {
                return (
                    <Fragment>
                        <Divider style = {{marginTop : '5px', marginBottom : '5px'}}/>
                        <Typography variant = 'caption' color = 'primary'>Attachments</Typography>
                        <div style = {{width : '100%', display : 'flex', flexDirection : 'row', flexWrap: 'wrap',}}>
                            {this.props.edit === false ? this.renderAttachmentList(this.getRecordContent()) : null}
                        </div>
                        <Divider style = {{marginTop : '5px', marginBottom : '5px'}}/>
                    </Fragment>
                )
            }
        }
    }

    // renderAttachmentList = (record) => {
    //     let attachments = null
    //     if (record.attachment_links.length > 0) {
    //         attachments = record.attachment_links.map(attachment => {
    //             console.log("Attachment : ", attachment)
    //             return (
    //                 <Attachment
    //                     server_name = {attachment.symbolic_server_name}
    //                     file_id = {attachment.file_id}
    //                     path = {attachment.src_file_name}
    //                     record = {this.props.record}
    //                     drl_url = {this.props.drl_url}
    //                 />
    //             )
    //         })
    //     }

    //     return attachments
    // }

    renderAttachmentList = (record) => {
        let attachments = null
        console.log("Attachment List : ", record.raw_fields.record_level_attachments)
        if (record.raw_fields.record_level_attachments.length > 0) {
            attachments = record.raw_fields.record_level_attachments.map(attachment => {
                console.log("Attachment : ", attachment)
                if (attachment.file_wv_address !== null) {
                    return (
                        <Attachment
                            width = '33%'
                            attachment = {attachment}
                            show_view = {true}
                            search_string = {this.props.search_string}
                            // search_string = {""}
                            highlight = {true}
                            show_title = {true}
                            server_name = {attachment.file_wv_address.wv_server_name}
                            file_id = {attachment.file_wv_address.wv_id}
                            file_name = {attachment.file_name}
                            file_type = {attachment.content_type}
                            path = {attachment.content_type}
                            record = {this.props.record}
                            drl_url = {this.props.drl_url}
                            re_attach = {this.props.re_attach}
                            attach_options = {this.props.attach_options}
                            re_attach_attachment = {(field_option, attachment_object) => this.props.re_attach_attachment(field_option, attachment_object)}
                        />
                    )
                } else {
                    return (<div></div>)
                }
            })
        }

        return attachments
    }

    renderCardContent = () => {
        return (
            <CardContent>
                {this.renderLabels(this.getLabels())}
                <div style = {{marginBottom : '5px'}}>
                    {this.props.edit === false ? this.renderAttachments(this.getRecordContent()) : null}
                </div>
                <div style = {{display : 'flex', flexDirection : 'column'}}>
                {
                    this.props.config.display.map(el => {
                        return this.renderContent(el, this.getRecordContent())
                    })
                }
                </div>
            </CardContent>
        )
    }


    render() {
        const { classes } = this.props
        return (
            <Fragment>
                <div ref = {this.component_width} style = {{width : '100%', maxHeight : this.props.height + "px", padding : '10px',overflow : 'auto'}}> 
                    <ThemeProvider theme = {blue_theme}>
                        <Card>
                            {this.renderCardHeader()}
                            <Divider/>
                            {this.renderCardContent()}
                        </Card>
                    </ThemeProvider>
                </div>
                <Dialog fullScreen open = {this.state.full_screen}>
                    <div style = {{width : '100%', maxHeight : "100%", padding : '10px',overflow : 'auto', backgroundColor : 'FAFBFC'}}> 
                        <ThemeProvider theme = {blue_theme}>
                            <Card>
                                {this.renderCardHeader()}
                                <Divider/>
                                {this.renderCardContent()}
                            </Card>
                        </ThemeProvider>
                    </div>
                </Dialog>
            </Fragment>
        );
    }
}

export default withStyles(styles)(JSONViewer);